
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/characters",
      function () {
        return require("private-next-pages/characters/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/characters"])
      });
    }
  